export default __webpack_public_path__ + "static/media/28.0dc8b49d.jpg";